import { Injectable } from "@angular/core";
import { EntityStoreService } from "../../../../shared/store/entity-store/entity-store.service";
import {
  EntityMetadata,
  EntityStoreState,
} from "../../../../shared/store/store-types.model";
import { FileType } from "../../models/file-type";
import { DocumentFacadeService } from "./document-facade.service";

@Injectable({ providedIn: "root" })
export class DocumentStoreService extends EntityStoreService<
  FileType,
  EntityMetadata,
  DocumentState
> {
  constructor() {
    super({
      ...EntityStoreService.initialState,
    });
  }
}

export interface DocumentState
  extends EntityStoreState<DocumentFacadeService> {}
